


import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Activities_Left from './Activities_Left'
import CulturalEle from "./CulturalEle";


import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'
import { Link } from 'react-router-dom'


function Main() {
    const [activeIndex, setActiveIndex] = useState(1);
    const getHeading = () => {
        switch (activeIndex) {
            case 0:
                return "Cultural";
            case 1:
                return "Clubs";
            case 2:
                return "Festivals";
            case 3:
                return "Sports";
            case 4:
                return "Social";
            default:
                return "Null";
        }
    };
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Our Stories" />
            <section className="project-detail">
                <div className="container">
                    <div
                        className="section-title center-align mb-50 wow fadeInDown animated"
                        data-animation="fadeInDown"
                        data-delay=".4s"
                    >
                       
                        <h2>{getHeading()}</h2>
                    </div>
                    <Row>
                        <Col md={4} className="c-left mb-25">
                            <Activities_Left activeIndex={activeIndex} />
                        </Col>
                        <Col md={8} className="c-left">
                            <Row>
                                <CulturalEle />
                            </Row>
                        </Col>
                        <>
                        </>
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
